import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import { TypeOfSelfDeclaration } from '../../../core/types/transport/enums/typeOfSelfDeclaration';
import { Order } from '../../../core/types/transport/order';
import { formatDate } from '../../../core/helpers/dates';

const declarationTypeLabels: Record<TypeOfSelfDeclaration, string> = {
  FillOutNow: 'Fylt ut',
  SentEarlier: 'Sendt tidligere',
  UploadNow: 'Lastet opp',
  WillSendLater: 'Vil sende senere',
};

interface DeclarationsTableProps {
  data: Order[];
}

export const DeclarationsTable = ({ data }: DeclarationsTableProps) => {
  const getDeclarationTypeName = (type: TypeOfSelfDeclaration) => declarationTypeLabels[type]
    ?? type;

  const navigate = useNavigate();

  const columns: GridColDef[] = [
    {
      field: 'createdTimestamp',
      headerName: 'Innsendt',
      flex: 1,
      type: 'string',
      valueGetter: ({ row }) => new Date(row.createdTimestamp),
      valueFormatter: ({ value }) => formatDate(value as Date),
    },
    {
      field: 'createdByName',
      headerName: 'Innsender',
      flex: 1,
      type: 'string',
    },
    {
      field: 'fromProject',
      headerName: 'Fra Prosjekt',
      flex: 1,
      type: 'string',
      valueGetter: ({ row }) => `${row.fromProject?.id ?? ''}
        ${row.fromProject?.projectName ?? ''}`,
    },
    {
      field: 'date',
      headerName: 'Leveringsdato',
      flex: 1,
      type: 'string',
      valueGetter: ({ row }) => new Date(row.date),
      valueFormatter: ({ value }) => formatDate(value as Date),
    },
    {
      field: 'contactPersonName',
      headerName: 'Kontakperson',
      flex: 1,
      type: 'string',
    },
    {
      field: 'contactPersonPhoneNumber',
      headerName: 'Telefon',
      flex: 1,
      type: 'string',
    },
    {
      field: 'typeOfDeclaration',
      headerName: 'Egenerklæring',
      flex: 1,
      type: 'string',
      valueGetter: ({ row }) => getDeclarationTypeName(row.typeOfDeclaration),
    },
  ];

  return (
    <div
      style={{
        flex: 1,
        maxHeight: 'calc(100vh - 152px)',
        maxWidth: 'calc(100vw - 32px)',
        minHeight: 108,
      }}
    >
      <DataGrid
        rows={data}
        columns={columns}
        getRowId={(row) => row.id}
        onRowClick={({ row }) => navigate(`/bestilling/transport/${row.id}`)}
        hideFooter
        sx={{
          '& .MuiDataGrid-row': {
            cursor: 'pointer',
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            fontWeight: 'bold',
          },
        }}
      />
    </div>
  );
};
